import { ArchivoDto } from "@models/archivo/archivoDto.model"
import { BaseDto } from "@models/base/baseDto.model"
import { DtoBase } from "@models/base/dtoBase.model"
import { EscritoDto } from "@models/escrito/escritoDto.model"
import { ExpedienteDto } from "@models/expediente/expedienteDto.model"

export class MovimientoExpedienteFilter extends BaseDto {
  public idExpediente!: number
  public idUsuario!: number
  public idsEstadoMovimientoExpediente!: number[]
  public idArchivoDto!: number
  public idEscrito!: number
  public fechaDesde!: string
  public fechaHasta!: string

}
